import { FormattedMessage } from 'react-intl';
import { Button } from 'components/Button';

export interface ActionButtonsProps {
  onApply: () => void;
  onCancel: () => void;
  applyDisabled?: boolean;
  invisible?: boolean;
}

export function ActionButtons({ onApply, onCancel, applyDisabled = false, invisible = false }: ActionButtonsProps) {
  return (
    <div className={invisible ? 'invisible' : ''}>
      <div className="flex justify-end gap-1 p-4">
        <Button priority="secondary" onClick={onCancel}>
          <FormattedMessage id="general.button.cancel" defaultMessage="Cancel" />
        </Button>
        <Button onClick={onApply} disabled={applyDisabled} className="shadow-none">
          <FormattedMessage id="general.button.apply" />
        </Button>
      </div>
    </div>
  );
}
